var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 mt-2 items-top justify-flex-start items-flex-start pr-6 w-max-content",
      class: _vm.parentInputClass,
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              attrs: {
                value: _vm.name,
                type: "search",
                placeholder: "Search for name, job title or skills",
                isIcon: "yes",
                iconStyle: "customIcon",
                inputClass: "customFormInput multiplePlaceholder",
                debounceTime: 500,
              },
              on: { input: _vm.handleNameInput },
            }),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("TitlesMultiselect", {
                  attrs: {
                    placeholder: "Select Job Title",
                    getcontainerStyle: "smallHeight",
                  },
                  model: {
                    value: _vm.titles,
                    callback: function ($$v) {
                      _vm.titles = $$v
                    },
                    expression: "titles",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("SkillsMultiselect", {
                  attrs: {
                    placeholder: "Select Skills",
                    getcontainerStyle: "smallHeight",
                  },
                  model: {
                    value: _vm.skillsIds,
                    callback: function ($$v) {
                      _vm.skillsIds = $$v
                    },
                    expression: "skillsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("ProfileCountrySelect", {
                  attrs: {
                    placeholder: "Select Countries",
                    multiple: "",
                    getcontainerStyle: "smallHeight",
                  },
                  model: {
                    value: _vm.countries,
                    callback: function ($$v) {
                      _vm.countries = $$v
                    },
                    expression: "countries",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("UiButtonMessage", {
          attrs: {
            buttonClass: "customAdd",
            buttonText: "Reset",
            textClass: "customText customOnlyText",
          },
          on: { click: _vm.handleReset },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }